export const MAP_COLORS = {
  primaryBlue: '#3478f6',
  defaultBlue: '#3b82f6',
  contactedOrange: '#f97316',
  white: '#ffffff',
  textDark: '#1f2937',
} as const;
